<template>
    <div class="bg-white px-3 index">
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <div class="u-f u-ac u-jsb">
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" :height="height" border v-loading="loading">
                <el-table-column prop="id" label="编号" width="70"></el-table-column>
                <el-table-column prop="hy_name" label="会员名称"></el-table-column>
                <el-table-column prop="hy_level" label="会员等级"></el-table-column>
                <el-table-column prop="medal_name" label="勋章名称"></el-table-column>
                <el-table-column prop="medal_level" label="勋章等级"></el-table-column>
                <el-table-column prop="fraction" label="积分等级"></el-table-column>
                <el-table-column prop="growth_value" label="成长值"></el-table-column>
                <el-table-column prop="growth_value" label="等级勋章">
                    <template slot-scope='scope'>
                        <el-image style="width: 50px; height: 50px" v-if="scope.row.file_info"
                            :src="scope.row.file_info[0].url" :preview-src-list="[scope.row.file_info[0].url]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="emphasis" label="侧重点"></el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column prop="remark" label="会员权益" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button size="mini" type="text" icon="el-icon-edit-outline" v-if="scope.row.hy_level==0"
                            @click="handleqy(scope.row,scope.$index)">查看</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="130" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-f u-ac u-jsb ft_mr">
                <div></div>
                <div>
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage" :page-sizes="[10, 30, 50, 100]" :page-size="pagesize"
                        layout="total, sizes, prev, pager, next, jumper" :total="count">
                    </el-pagination>
                </div>
            </div>

        </div>
        <el-dialog title="会员设置" :visible.sync="dialogVisible" center top="20px" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="会员名称" prop='hy_name'>
                        <el-input v-model="ruleForm.hy_name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="会员等级" prop='hy_level'>
                        <el-input v-model="ruleForm.hy_level" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="勋章名称" prop='medal_name'>
                        <el-input v-model="ruleForm.medal_name" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="勋章等级" prop='medal_level'>
                        <el-input v-model="ruleForm.medal_level" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="积分等级" prop='fraction'>
                        <el-input v-model="ruleForm.fraction" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="成长值">
                        <el-input v-model="ruleForm.growth_value" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="等级勋章" required>
                        <el-upload class="avatar-uploader" action="/admin/uploadFile" name="img" ref="upload" :limit="1"
                            :headers="{ token:$store.state.user.token }" :data="{ image_class_id:'72',file_type:'1'}"
                            :file-list="ruleForm.lb_mapList" :on-success="uploadSuccess" :on-remove="uploadRmove"
                            list-type="picture-card">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="金额">
                        <el-input v-model="ruleForm.price" size="small" type="number"></el-input>
                    </el-form-item>
                    <el-form-item label="侧重点">
                        <el-input v-model="ruleForm.emphasis" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="ruleForm.remark">
                        </el-input>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 权益-->
        <el-dialog title="会员权益" :visible.sync="vipqy_list" top="50px" width="60%" class="dialogs">
            <el-divider></el-divider>
            <viplist ref="viplist" />
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="vipqy_list=false" size="small">确定</el-button>
            </span>
        </el-dialog>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    import viplist from "./viplist.vue";
    export default {
        components: {
            viplist
        },
        data() {
            return {
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                count: 0,
                height: null,
                // 
                eid: '',
                dialogVisible: false,
                subloading: false,
                ruleForm: {
                    hy_level: '',
                    hy_name: '',
                    medal_name: '',
                    medal_level: '',
                    fraction: '',
                    growth_value: '',
                    emphasis: '',
                    remark: '',
                    lb_mapList: [],
                    price: 0
                },
                mapListed: [],
                rule: {
                    hy_name: [{
                        required: true,
                        message: '请填写会员名称',
                        trigger: 'blur'
                    }],
                    hy_level: [{
                        required: true,
                        message: '请填写会员等级',
                        trigger: 'blur'
                    }],
                    medal_name: [{
                        required: true,
                        message: '请填写勋章名称',
                        trigger: 'blur'
                    }],
                    medal_level: [{
                        required: true,
                        message: '请填写勋章等级',
                        trigger: 'blur'
                    }],
                    fraction: [{
                        required: true,
                        message: '请填写会员名称',
                        trigger: 'blur'
                    }],
                    price: [{
                        required: true,
                        message: '请填写金额',
                        trigger: 'blur'
                    }],
                },
                vipqy_list: false,
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 220 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 220 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios.post("/admin/pc/Medal/medalList", {
                        page: this.currentPage,
                        page_count: that.pagesize
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data.list
                        that.count = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = ''
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm = {
                    hy_level: '',
                    hy_name: '',
                    medal_name: '',
                    medal_level: '',
                    fraction: '',
                    growth_value: '',
                    emphasis: '',
                    remark: '',
                    lb_mapList: [],
                    price: 0
                }
                this.mapListed = []
            },
            submit(formName) {
                let that = this

                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.mapListed.length == 0) return this.$message.error('请上传等级勋章')
                        that.subloading = true
                        let urls;
                        if (this.eid) {
                            urls = "/admin/pc/Medal/editMedal"
                        } else {
                            urls = "/admin/pc/Medal/addMedal"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                hy_level: that.ruleForm.hy_level,
                                hy_name: that.ruleForm.hy_name,
                                medal_name: that.ruleForm.medal_name,
                                medal_level: that.ruleForm.medal_level,
                                fraction: that.ruleForm.fraction,
                                growth_value: that.ruleForm.growth_value,
                                emphasis: that.ruleForm.emphasis,
                                remark: that.ruleForm.remark,
                                file_info: this.mapListed,
                                price: that.ruleForm.price

                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisible = true
                that.eid = row.id
                axios
                    .post("/admin/pc/Medal/medalInfo", {
                        id: that.eid,
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        that.ruleForm.hy_level = data.hy_level
                        that.ruleForm.hy_name = data.hy_name
                        that.ruleForm.medal_name = data.medal_name
                        that.ruleForm.medal_level = data.medal_level
                        that.ruleForm.fraction = data.fraction
                        that.ruleForm.growth_value = data.growth_value
                        that.ruleForm.emphasis = data.emphasis
                        that.ruleForm.remark = data.remark
                        that.ruleForm.lb_mapList = data.file_info ? data.file_info : []
                        that.ruleForm.price = data.price
                        that.mapListed = data.file_info

                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/Medal/delmedal", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            uploadSuccess(response, file, fileList) {
                let that = this
                if (response.code == "201") {
                    that.$nextTick(() => {
                        let mainImg = that.$refs.upload;
                        if (mainImg) {
                            mainImg.uploadFiles.forEach((element, index) => {
                                if (file.uid == element.uid) {
                                    mainImg.uploadFiles.splice(index, 1)
                                }
                            });
                        }
                    })
                    that.$alert(response.msg)
                    return;
                }
                that.$message({
                    message: '上传成功',
                    type: 'success'
                });
                that.mapListed.push(response.data)
            },
            uploadRmove(file, fileList) {
                var index = this.mapListed.findIndex(item => item.id == file.id)
                this.mapListed.splice(index, 1)
            },
            handleqy(row, index) {
                this.vipqy_list = true
                this.$nextTick(() => {
                    this.$refs.viplist.textId = row.level
                    this.$refs.viplist.getlist(row.level)
                    // this.$refs.votelist.votelist=row.content
                })
            },
        },

    };
</script>


<style scoped>
</style>